<div class="col-sm-12 coldx">
	<h3 class="title1level" style="margin-bottom: 20px;">Storico versioni documento</h3>
	<ng-template ngFor let-file [ngForOf]="filesData" let-i=index>
		<div class="row">			
			<div labelTextInput [typeLabel]="'text'" class="col-sm-4 bloccodati" [labelInput]="'Data riferimento'"
				[valueInput]="file.dataRiferimento | date:'dd/MM/yyyy'"></div>

			<div labelTextInput [typeLabel]="'text'" class="col-sm-4 bloccodati" [labelInput]="'Autore'"
				[valueInput]="file.autore"></div>

			<div labelTextInput [typeLabel]="'text'" class="col-sm-2 bloccodati" [labelInput]="'Versione'"
				[valueInput]="file.versione"></div>
			<div class="col-sm-2 bloccodati">
				<button type="button" class="btn btn-link p-0" 
						(click)="downloadDocByIdDocumentale(file.refDocumentale)">
					<span class="glyphicon glyphicon-save" aria-hidden="true"></span> 
					<span class="sr-only">Scarica il documento {{ file.nome }}</span>Scarica versione
				</button>
				<ng-container *ngIf="isFilePresent(file)">    
					<!-- Anteprima disponibile -->
					<a *ngIf="canViewFile(file)"
						href="javascript:void(0)"
						aria-label="mostra anteprima documento"
						(click)="viewDoc(file)"
						class="btn btn-link p-0">
						<span class="glyphicon glyphicon-eye-open"></span>
						Anteprima
					</a>

					<!-- Anteprima NON disponibile -->
					<a *ngIf="!canViewFile(file)"
						href="javascript:void(0)"
						aria-label="anteprima non disponibile"
						class="btn btn-link p-0"
						[appTooltip]="'L’anteprima non è disponibile perché il file supera le dimensioni massime consentite'"
						[appTooltipEnabled]="checkMaxLimitExceeded(file)">
						<span class="glyphicon glyphicon-eye-close"></span>
						Anteprima
    				</a>
  				</ng-container>
   			</div>

		</div>
		<div class="row">
			<div labelTextInput [typeLabel]="'text'" class="col-sm-4 bloccodati" [labelInput]="'Tipo'"
     			[valueInput]="file.tipoDocumento"></div>

			<div labelTextInput [typeLabel]="'text'" class="col-sm-4 bloccodati" [labelInput]="'Nome file'"
				[valueInput]="file.nomeFile"></div>

			<div labelTextInput [typeLabel]="'text'" class="col-sm-4 bloccodati" [labelInput]="'Provenienza'"
				[valueInput]="file.provenienza"></div>
		</div>
		<div class="row">
			<div labelTextInput [typeLabel]="'text'" class="col-sm-6 bloccodati" [labelInput]="'Stato documento'"
				 [valueInput]="file.statoDocumento"></div>
			<div *ngIf="file.motivoAssenzaFirma" labelTextInput  [typeLabel]="'text'" class="col-sm-6 bloccodati" [labelInput]="'Tipologia firma'"
				 [valueInput]="file.motivoAssenzaFirma"></div>
		</div>
		<div class="row">			
			<div labelTextInput [typeLabel]="'text'" class="col-sm-12 bloccodati" [labelInput]="'Modalità formazione documento'"
     			[valueInput]="file.modalitaFormazioneDocumento"></div>
		</div>
		<div class="row">		
			<div labelTextInput [typeLabel]="'text'" class="col-sm-12 bloccodati" [labelInput]="'Motivo della revisione'"
				[valueInput]="file.descrizione ? file.descrizione : ''"></div>
		</div>
	<hr>
	</ng-template>
</div>